import { FC } from "react";
import "../../sass/components/animaciones/DeclinedRounded.scss";

const DeclinedRounded: FC = () => {
  return (
    <div className="wrapperDeclinedRounded">
      <svg
        className="DeclinedRounded"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        height="26"
        width="26"
        version="1.1"
        fill="#b9372a"
      >
        <metadata id="metadata10"></metadata>
        <defs id="defs8" />
        <path
          id="path2"
          d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8 2c1.3 0 2.5 0.4 3.5 1.1l-8.4 8.4c-0.7-1-1.1-2.2-1.1-3.5 0-3.3 2.7-6 6-6zM8 14c-1.3 0-2.5-0.4-3.5-1.1l8.4-8.4c0.7 1 1.1 2.2 1.1 3.5 0 3.3-2.7 6-6 6z"
          fill="#b9372a"
        />
      </svg>
    </div>
  );
};

export { DeclinedRounded };
